export default "/_assets/arrow_white.60fcf58a.svg"